import React, { useRef, useState, useLayoutEffect, useEffect } from "react";
import { outroDate } from "../assets/data/subData";

const Outro = () => {
    const outro = useRef();
    const outro_tit = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (outro.current) {
                        if (entry.isIntersecting) {
                            outro_tit.current.classList.add("active");
                        } else {
                            outro_tit.current.classList.remove("active");
                        }
                    }
                });
            },
            { threshold: 0.2 }
        );

        if (outro.current) {
            observer.observe(outro.current);
        }
    }, [window.innerWidth]);

    return (
        <>
            <div>
                <section id="OUTRO" className="outro" ref={outro}>
                    <div className="outro_content">
                        <div className="outro_text-tit" ref={outro_tit}>
                            <h2 className="text-title">
                                <div className="tit_star">
                                    <picture>
                                        <source
                                            media="(min-width:1024px)"
                                            srcSet={outroDate.outroTitImg[0].pcSrc}
                                        />
                                        <source
                                            media="(min-width:768px) and (max-width:1023px)"
                                            srcSet={outroDate.outroTitImg[0].pcSrc}
                                        />
                                        <source
                                            media="(min-width:0px) and (max-width:767px)"
                                            srcSet={outroDate.outroTitImg[0].pcSrc}
                                        />
                                        <img
                                            src={outroDate.outroTitImg[0].pcSrc}
                                            alt={outroDate.outroTitImg[0].alt}
                                        />
                                    </picture>
                                </div>
                                <div className="tit_law">
                                    <picture>
                                        <source
                                            media="(min-width:1024px)"
                                            srcSet={outroDate.outroTitImg[1].pcSrc}
                                        />
                                        <source
                                            media="(min-width:768px) and (max-width:1023px)"
                                            srcSet={outroDate.outroTitImg[1].pcSrc}
                                        />
                                        <source
                                            media="(min-width:0px) and (max-width:767px)"
                                            srcSet={outroDate.outroTitImg[1].pcSrc}
                                        />
                                        <img
                                            src={outroDate.outroTitImg[1].pcSrc}
                                            alt={outroDate.outroTitImg[1].alt}
                                        />
                                    </picture>
                                </div>
                                <div className="tit_deajeon">
                                    <picture>
                                        <source
                                            media="(min-width:1024px)"
                                            srcSet={outroDate.outroTitImg[2].pcSrc}
                                        />
                                        <source
                                            media="(min-width:768px) and (max-width:1023px)"
                                            srcSet={outroDate.outroTitImg[2].pcSrc}
                                        />
                                        <source
                                            media="(min-width:0px) and (max-width:767px)"
                                            srcSet={outroDate.outroTitImg[2].pcSrc}
                                        />
                                        <img
                                            src={outroDate.outroTitImg[2].pcSrc}
                                            alt={outroDate.outroTitImg[2].alt}
                                        />
                                    </picture>
                                </div>
                            </h2>
                        </div>
                        <div className="outro_flow">
                            <div className="flow-wrap">
                                <div className="flow-list list01">
                                    <ul className="flow-box">
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[0].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[0].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[0].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[0].pcSrc}
                                                    alt={outroDate.outroflowImg[0].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[1].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[1].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[1].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[1].pcSrc}
                                                    alt={outroDate.outroflowImg[1].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[2].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[2].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[2].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[2].pcSrc}
                                                    alt={outroDate.outroflowImg[2].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[3].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[3].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[3].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[3].pcSrc}
                                                    alt={outroDate.outroflowImg[3].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li className="large-img">
                                            <div className="keyword">
                                                <span>Relaxed</span>
                                            </div>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[4].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[4].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[4].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[4].pcSrc}
                                                    alt={outroDate.outroflowImg[4].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[5].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[5].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[5].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[5].pcSrc}
                                                    alt={outroDate.outroflowImg[5].alt}
                                                />
                                            </picture>
                                        </li>
                                    </ul>
                                    <ul className="flow-box">
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[0].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[0].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[0].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[0].pcSrc}
                                                    alt={outroDate.outroflowImg[0].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[1].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[1].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[1].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[1].pcSrc}
                                                    alt={outroDate.outroflowImg[1].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[2].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[2].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[2].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[2].pcSrc}
                                                    alt={outroDate.outroflowImg[2].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[3].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[3].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[3].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[3].pcSrc}
                                                    alt={outroDate.outroflowImg[3].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li className="large-img">
                                            <div className="keyword">
                                                <span>Relaxed</span>
                                            </div>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[4].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[4].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[4].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[4].pcSrc}
                                                    alt={outroDate.outroflowImg[4].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[5].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[5].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[5].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[5].pcSrc}
                                                    alt={outroDate.outroflowImg[5].alt}
                                                />
                                            </picture>
                                        </li>
                                    </ul>
                                </div>
                                <div className="flow-list list02">
                                    <ul className="flow-box">
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[6].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[6].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[6].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[6].pcSrc}
                                                    alt={outroDate.outroflowImg[6].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li className="large-img">
                                            <div className="keyword">
                                                <span>Honest</span>
                                            </div>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[7].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[7].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[7].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[7].pcSrc}
                                                    alt={outroDate.outroflowImg[7].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[8].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[8].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[8].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[8].pcSrc}
                                                    alt={outroDate.outroflowImg[8].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[9].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[9].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[9].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[9].pcSrc}
                                                    alt={outroDate.outroflowImg[9].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[10].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[10].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[10].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[10].pcSrc}
                                                    alt={outroDate.outroflowImg[10].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li className="large-img">
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[11].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[11].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[11].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[11].pcSrc}
                                                    alt={outroDate.outroflowImg[11].alt}
                                                />
                                            </picture>
                                        </li>
                                    </ul>
                                    <ul className="flow-box">
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[6].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[6].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[6].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[6].pcSrc}
                                                    alt={outroDate.outroflowImg[6].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li className="large-img">
                                            <div className="keyword">
                                                <span>Honest</span>
                                            </div>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[7].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[7].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[7].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[7].pcSrc}
                                                    alt={outroDate.outroflowImg[7].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[8].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[8].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[8].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[8].pcSrc}
                                                    alt={outroDate.outroflowImg[8].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[9].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[9].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[9].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[9].pcSrc}
                                                    alt={outroDate.outroflowImg[9].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[10].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[10].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[10].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[10].pcSrc}
                                                    alt={outroDate.outroflowImg[10].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li className="large-img">
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[11].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[11].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[11].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[11].pcSrc}
                                                    alt={outroDate.outroflowImg[11].alt}
                                                />
                                            </picture>
                                        </li>
                                    </ul>
                                </div>
                                <div className="flow-list list03">
                                    <ul className="flow-box">
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[12].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[12].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[12].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[12].pcSrc}
                                                    alt={outroDate.outroflowImg[12].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li className="large-img">
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[13].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[13].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[13].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[13].pcSrc}
                                                    alt={outroDate.outroflowImg[13].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[14].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[14].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[14].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[14].pcSrc}
                                                    alt={outroDate.outroflowImg[14].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <div className="keyword">
                                                <span>Respectful</span>
                                            </div>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[15].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[15].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[15].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[15].pcSrc}
                                                    alt={outroDate.outroflowImg[15].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[16].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[16].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[16].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[16].pcSrc}
                                                    alt={outroDate.outroflowImg[16].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li className="large-img">
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[17].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[17].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[17].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[17].pcSrc}
                                                    alt={outroDate.outroflowImg[17].alt}
                                                />
                                            </picture>
                                        </li>
                                    </ul>
                                    <ul className="flow-box">
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[12].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[12].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[12].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[12].pcSrc}
                                                    alt={outroDate.outroflowImg[12].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li className="large-img">
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[13].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[13].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[13].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[13].pcSrc}
                                                    alt={outroDate.outroflowImg[13].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[14].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[14].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[14].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[14].pcSrc}
                                                    alt={outroDate.outroflowImg[14].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <div className="keyword">
                                                <span>Respectful</span>
                                            </div>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[15].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[15].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[15].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[15].pcSrc}
                                                    alt={outroDate.outroflowImg[15].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li>
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[16].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[16].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[16].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[16].pcSrc}
                                                    alt={outroDate.outroflowImg[16].alt}
                                                />
                                            </picture>
                                        </li>
                                        <li className="large-img">
                                            <picture>
                                                <source
                                                    media="(min-width:1024px)"
                                                    srcSet={outroDate.outroflowImg[17].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:768px) and (max-width:1023px)"
                                                    srcSet={outroDate.outroflowImg[17].pcSrc}
                                                />
                                                <source
                                                    media="(min-width:0px) and (max-width:767px)"
                                                    srcSet={outroDate.outroflowImg[17].pcSrc}
                                                />
                                                <img
                                                    src={outroDate.outroflowImg[17].pcSrc}
                                                    alt={outroDate.outroflowImg[17].alt}
                                                />
                                            </picture>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="outro_text-sub">
                            <p className="text-sub">
                                스타 법무법인은 고객님을 위한 법률공간으로
                                <br />더 따뜻한, 세심한, 뜻깊은 경험을 선사합니다.
                            </p>
                        </div>
                    </div>
                    <div className="outro_slogan">
                        <ul>
                            <li>One Step, a Better Tomorrow</li>
                            <li>One Step, a Better Tomorrow</li>
                            <li>One Step, a Better Tomorrow</li>
                            <li>One Step, a Better Tomorrow</li>
                        </ul>
                        <ul>
                            <li>One Step, a Better Tomorrow</li>
                            <li>One Step, a Better Tomorrow</li>
                            <li>One Step, a Better Tomorrow</li>
                            <li>One Step, a Better Tomorrow</li>
                        </ul>
                    </div>
                    <div className="outro_others">
                        <div className="others-links">
                            <a
                                href="https://star-law.com/04_customer/starlawfirm_community.php"
                                target="_blank"
                                className="community-box"
                            >
                                <div className="txt-wrap">
                                    <div className="link-tit">COMMUNITY</div>
                                    <div className="link-btn">
                                        <span>둘러보기</span>
                                    </div>
                                </div>
                                <picture className="img-wrap">
                                    <source
                                        media="(min-width:1024px)"
                                        srcSet={outroDate.outroLinkImg[0].pcSrc}
                                    />
                                    <source
                                        media="(min-width:768px) and (max-width:1023px)"
                                        srcSet={outroDate.outroLinkImg[0].tabSrc}
                                    />
                                    <source
                                        media="(min-width:0px) and (max-width:767px)"
                                        srcSet={outroDate.outroLinkImg[0].moSrc}
                                    />
                                    <img
                                        src={outroDate.outroLinkImg[0].pcSrc}
                                        alt={outroDate.outroLinkImg[0].alt}
                                    />
                                </picture>
                            </a>
                            <a
                                href="https://star-law.com/01_about/contact_us/"
                                target="_blank"
                                className="contact-box"
                            >
                                <div className="txt-wrap">
                                    <div className="link-tit">CONTACT US</div>
                                    <div className="link-btn">
                                        <span>확인하기</span>
                                    </div>
                                </div>
                                <picture className="img-wrap">
                                    <source
                                        media="(min-width:1024px)"
                                        srcSet={outroDate.outroLinkImg[1].pcSrc}
                                    />
                                    <source
                                        media="(min-width:768px) and (max-width:1023px)"
                                        srcSet={outroDate.outroLinkImg[1].tabSrc}
                                    />
                                    <source
                                        media="(min-width:0px) and (max-width:767px)"
                                        srcSet={outroDate.outroLinkImg[1].moSrc}
                                    />
                                    <img
                                        src={outroDate.outroLinkImg[1].pcSrc}
                                        alt={outroDate.outroLinkImg[1].alt}
                                    />
                                </picture>
                            </a>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default Outro;
